import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { PageLoader } from 'routes/PrivateRouter';
import {
  CloseChecklistRoutes,
  CloseChecklistV1Routes,
} from 'routes/close/CloseChecklistRoutes';
import { CloseOverviewRoutes } from 'routes/close/CloseOverviewRoutes';
import {
  CloseReconciliationsRoutes,
  CloseReconciliationsV1Routes,
} from 'routes/close/CloseReconciliationsRoutes';
import {
  closeChecklistURLs,
  closeJournalEntriesURLs,
  closeURLs,
} from 'routes/close/closeURLs';

import { CloseContextProvider } from 'hooks/close/CloseContext';

import { featureFlags } from 'utils/config/featureFlags';

const DemoJournalEntries = lazy(() =>
  import('pages/period-close/checklist-v2/demo/DemoJournalEntries').then(
    (m) => ({
      default: m.DemoJournalEntries,
    })
  )
);

export const CloseRoutes = [
  {
    path: closeURLs.base,
    element: (
      <CloseContextProvider>
        <Outlet />
      </CloseContextProvider>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={closeChecklistURLs.list} replace />,
      },

      // == CLOSE OVERVIEW  ==
      CloseOverviewRoutes,

      // == CHECKLIST ==
      CloseChecklistRoutes,
      CloseChecklistV1Routes,

      // == JOURNAL ENTRIES (demo only) ==
      ...(featureFlags.FF__CLOSE_DEMO_PAGES
        ? [
            {
              path: closeJournalEntriesURLs._baseRelativePath,
              element: (
                <Suspense fallback={<PageLoader />}>
                  <DemoJournalEntries />
                </Suspense>
              ),
            },
          ]
        : []),

      // == RECONCILIATION ==
      CloseReconciliationsRoutes,
      CloseReconciliationsV1Routes,

      // Catch-all route: redirect any unmatched /close/* paths to base
      {
        path: '*',
        element: <Navigate to={closeURLs.base} replace />,
      },
    ],
  },
];
